import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map,switchMap, withLatestFrom } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { AdminStatsState } from "../../models/mp-admin/admin-stats-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class AdminStatsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.stats.get),
			withLatestFrom(this.store.select(MpAdminSelectors.stats)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.stats.getSuccess(state))
					: of(MpAdminActions.stats.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.stats.getApi),
			withLatestFrom(this.store.select(MpAdminSelectors.stats)),
			switchMap(() =>
				this.adminService.stats().pipe(
					map((stats) => MpAdminActions.stats.getSuccess({ stats, loading: false })),
					catchError((error) => of(MpAdminActions.stats.getFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private actions: Actions,
		private adminService: MpAdminService
	) {}

	private canUseStoreValue(action, state: AdminStatsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
